/**
 * @file Drag source services base component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DragSourceBaseComponent } from '../drag-source-base/drag-source-base.component';
import { SortDescriptor } from '../../core/helpers/sort-descriptor';
import { SortDirection } from '../../core/helpers/sort-direction';
/** Drag source services base component. */
var DragSourceServicesBaseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DragSourceServicesBaseComponent, _super);
    function DragSourceServicesBaseComponent(domainService, executorsService, alertsService, gridService, localisationService) {
        var _this = _super.call(this, domainService, executorsService, alertsService, gridService) || this;
        _this.domainService = domainService;
        _this.executorsService = executorsService;
        _this.alertsService = alertsService;
        _this.gridService = gridService;
        _this.localisationService = localisationService;
        _this.addSorting(new SortDescriptor('Start', 'Start', SortDirection.Ascending, 1));
        return _this;
    }
    /**
     * Initiate the executors for given source
     */
    DragSourceServicesBaseComponent.prototype.initiateExecutors = function () {
        // Get the executors
        this.availableExecutors = this.executorsService.getExecutors('drop', 'Service');
        // Default pick the first available drop method
        this.selectedExecutorName = (this.availableExecutors.length > 0) ? this.availableExecutors[0].name : undefined;
    };
    DragSourceServicesBaseComponent.prototype.formatDate = function (date) {
        var formattedDate = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
        return formattedDate;
    };
    return DragSourceServicesBaseComponent;
}(DragSourceBaseComponent));
export { DragSourceServicesBaseComponent };
